import { setItemSessionStorage } from 'src/utils/cart/setCartItemsInSessionStorage';

export function resetCartItemsInSessionStorage(): void {
    setItemSessionStorage('cartItems', []);
    setItemSessionStorage('cartItemsByMenuItem', []);
}
